angular.module('PatientApp').controller('RedirectCtrl', [
    '$rootScope', '$scope', 'SsoService', '$state', '$q', '$timeout', '$log',
    function($rootScope, $scope, SsoService, $state, $q, $timeout, $log) {
        $scope.showRedirectModal = false;
        $rootScope.$on('redirect:modal', function () {
            $scope.showRedirectModal = true;
        });
        $rootScope.$on('redirect:tab', function (event, options) {
            $scope.url = options.provider.brandedWalletUrl + '/#/redirect';
            $scope.delaySeconds = options.delaySeconds || 1;
            $scope.newTab = open($scope.url, '_blank');
            $q.all([
                SsoService.getToken({
                    providerId: options.provider.id,
                    context: options.context || {},
                    ssoType: 'BRANDING'
                }),
                $timeout(function() {}, $scope.delaySeconds * 1000)
            ]).then(function(results) {
                var token = results[0];
                $scope.ssoUrl = options.provider.brandedWalletUrl + '/#/sso/token/' + token;
                $scope.newTab.location.replace($scope.ssoUrl);
            }).catch(function(error) {
                $scope.newTab.close();
                $rootScope.$emit('redirect:error', error);
            });
        });
        $rootScope.$on('redirect:complete', function (event, options) {
            var handlers = {
                stateGo: function() {
                    if (options.stateGo) {
                        var stateGoOptions = options.stateGo.options || {};
                        stateGoOptions.location = 'replace';
                        return $state.go(options.stateGo.to,
                            options.stateGo.toParams || {},
                            stateGoOptions);
                    } else {
                        return $q.when();
                    }
                },
                emit: function() {
                    if (Array.isArray(options.emit)) {
                        return $scope.$emit.apply($scope, options.emit);
                    } else {
                        return $q.when();
                    }
                }
            };
            return handlers.stateGo().then(handlers.emit).then(function() {
                $scope.showRedirectModal = false;
            }).catch(function(error) {
                $rootScope.$emit('redirect:error', error);
            });
        });
        $rootScope.$on('redirect:error', function (event, error) {
            $scope.redirectError = error || 'unknown error';
            $scope.showRedirectModal = false;
            $log.error('redirect error', error);
        });
    }]);